/* @flow */

import React, { PureComponent } from 'react';
import styled from 'styled-components';

import FlexBox from './FlexBox';
import Icon from './Icon';

const ChangeDegreeBox = styled(FlexBox)`
  width: 32px;
  height: 16px;
  border-radius: 3px;
  background: ${({ theme, direction }) => (direction === 'up' ? theme.up : theme.down)};
  opacity: ${({ degree, type, direction }) => {
    if (
      (degree === 1 && type === 'AbnormalPrice') ||
      (degree === 3 && type === 'PriceBreakthroughs' && direction === 'up') ||
      (degree === 1 && type === 'PriceBreakthroughs' && direction === 'down')
    ) {
      return 0.45;
    }
    if (
      (degree === 2 && type === 'AbnormalPrice') ||
      (degree === 2 && type === 'PriceBreakthroughs')
    ) return 0.8;
    return 1;
  }};
`;

const Icons = styled(FlexBox)`
  transform: scale(0.8);
  .iconfont {
    margin-left: -2px;
  }
  .iconfont:first-of-type {
    margin: 0;
  }
`;

type Props = {
  direction: string,
  degree: number,
  type: string,
};

export default class ChangeDegree extends PureComponent<Props> {
  static defaultProps = {
    direction: 'up',
    degree: 1,
  };

  _renderIcons = () => {
    const { direction, degree, type } = this.props;
    if (type === 'AbnormalPrice') {
      const IconsArray = [];
      for (let i = 0; i < degree; i++) {
        IconsArray.push(
          <Icon key={i} type={direction === 'up' ? 'zhang' : 'die'} size={12} color="#fff" />
        );
      }
      return IconsArray;
    }

    return <Icon type={`${direction}_${degree}`} size={12} color="#fff" />;
  };

  render() {
    const { direction, degree, type } = this.props;
    return (
      <ChangeDegreeBox direction={direction} degree={degree} type={type} justify="center">
        <Icons align="center">{this._renderIcons()}</Icons>
      </ChangeDegreeBox>
    );
  }
}
